import { useEffect, useMemo } from 'react';
import { Form, Row, Col, Button } from "react-bootstrap";
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.css';
import toast, { Toaster } from "react-hot-toast"

const HeaderSection = ({
  selectors,
  selected,
  setSelected,
  setCsvDownloadTracker,
}) => {
  const handleChange = (key, value) => {
    setSelected((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const resetFilters = () => {
    window.location.reload();
  };

  const downLoadCsv = () => {
    setCsvDownloadTracker(true)
  }

  const SelectorComponent = ({ fieldKey }) => {
    useEffect(() => {
      new TomSelect(`#select-element-${fieldKey}`, {
        placeholder: 'Select to filter',
        maxItems: null, // Allows multiple selections
        create: false, // Enable the ability to create new options
        items: selected[fieldKey] // Set default selected items
      })
    }, [selectors]);

    return (
      <Form.Group as={Row} className='align-items-center mb-2'>
        <Form.Label column xs={2}>
          {fieldKey.toUpperCase()}
        </Form.Label>
        <Col xs={10} className='grossmargin-select-wrapper'>
          <div className="tom-select-wrapper">
            <select
              id={`select-element-${fieldKey}`}
              multiple
              onChange={(e) => handleChange(fieldKey, Array.from(e.target.selectedOptions, option => option.value))}
            >
              {selectors[fieldKey] && selectors[fieldKey].map((option, index) => (
                <option key={index} value={option}>{option}</option>
              ))}
            </select>
          </div>
        </Col>
      </Form.Group>
    )
  }

  const DateComponent = ({ fieldKey }) => (
    <Form.Group as={Row} className='align-items-center mb-2'>
      <Form.Label column xs={3}>
        {fieldKey.toUpperCase()}
      </Form.Label>
      <Col xs={9}>
        <Form.Control
          type='date'
          id={fieldKey}
          defaultValue={selected[fieldKey]}
          onChange={(e) => handleChange(fieldKey, e.target.value)}
        />
      </Col>
    </Form.Group>
  )

  const memorizedDateRow = useMemo(() => (
    <Row>
        <Col xs={4}>
          <DateComponent fieldKey={"start"} />
        </Col>
        <Col xs={4}>
          <DateComponent fieldKey={"end"} />
        </Col>
        <Col className="ml-auto" xs={1}>
          <Button onClick={resetFilters} size='sm'>
            Reset Filters
          </Button>
        </Col>
        <Col xs={1}>
          <Button onClick={downLoadCsv} size='sm'>
            Export Table
          </Button>
        </Col>
      </Row>
  ), [])

  return (
    <div>
      <Toaster position='bottom-right' />
      <Row>
        <Col md={4}>
          <SelectorComponent fieldKey={"sales"} />
        </Col>
        <Col md={5}>
          <SelectorComponent fieldKey={"customer"} />
        </Col>
        <Col md={3}>
          <SelectorComponent fieldKey={"AM"} />
        </Col>
      </Row>
    {memorizedDateRow}
    </div>
  )
}

export default HeaderSection
